import { privateRoutesPath } from "../Routes";

const DESTINATION_ROUTE_MAP = {
  LEAD: privateRoutesPath.LEADS,
  SALESORDER: privateRoutesPath.ORDER,
  INVOICE: privateRoutesPath.INVOICE,
  CUSTOMER: privateRoutesPath.CUSTOMER,
};

const EDIT_ROUTE_MAP = {
  LEAD: privateRoutesPath.EDIT_LEAD,
  SALESORDER: privateRoutesPath.VIEW_ORDER,
  INVOICE: privateRoutesPath.EDIT_INVOICE,
  CUSTOMER: privateRoutesPath.EDIT_CUSTOMER,
};

export const resolveNotificationRoute = (item) => {
  if (!item || !(item.destinationType && item.clickAble)) {
    return null;
  }

  const baseRoute = item.destinationId
    ? EDIT_ROUTE_MAP[item.destinationType]
    : DESTINATION_ROUTE_MAP[item.destinationType];

  if (!baseRoute) return null;

  return item.destinationId
    ? `${baseRoute}/${item.destinationId}`
    : baseRoute;
};
